  (function () {
    if (window.__hlUxTracked) return;
    window.__hlUxTracked = true;

    function ga() {
      try {
        if (typeof window.gtag === 'function') window.gtag.apply(null, arguments);
      } catch (e) {}
    }
    function group() {
      return (window.__hlGaParams && window.__hlGaParams.content_group) || 'other';
    }

    /* A short, stable-ish name for an element. id first because it survives a
       restyle, then a test hook, then tag + first class. Anything longer than
       60 chars is a CSS path nobody will read in a report. */
    function describe(el) {
      if (!el || !el.tagName) return 'unknown';
      if (el.id) return '#' + el.id;
      var hook = el.getAttribute && (el.getAttribute('data-testid') || el.getAttribute('data-block-id'));
      if (hook) return '[' + hook.slice(0, 40) + ']';
      var tag = el.tagName.toLowerCase();
      var cls = (el.className && typeof el.className === 'string')
        ? el.className.trim().split(/\s+/)[0]
        : '';
      return (cls ? tag + '.' + cls : tag).slice(0, 60);
    }

    /* ---------- js_error ----------
       Bound first and outside any readiness check: the errors most worth having
       are the ones that happen before the page finishes loading.

       Grouping strips the parts that make every occurrence unique — numbers,
       quoted values, URLs — so "Cannot read properties of null (reading 'x')"
       from one script is one group no matter how many visitors hit it. */
    var errorsSent = 0;
    function normalise(msg) {
      return String(msg || 'unknown')
        .replace(/https?:\/\/[^\s)'"]+/g, '<url>')
        .replace(/\b\d+\b/g, '<n>')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 90);
    }
    /* Three additions, 2026-09-26, from breaking 812 errors down by group:
         - error_source (file:line:col) and error_stack (top frames): the group
           alone could not locate "M_ID", "srcdoc" or "unknown";
         - third_party: pixel.modern.js, fbevents.js, standard-actions.js and the
           rest are Shopify's or Meta's, blocked by an ad blocker or broken in an
           old browser. Flagged, not dropped, so a report can split "ours" from
           "theirs" with one filter;
         - leaving: Safari fires `error` on every image whose download is cut
           off by navigating away. The four 3.5 MB PNG room photos were logged
           as "resource failed" in ~27 sessions each for exactly this reason,
           though every one of them returns 200. A resource error after pagehide
           is a visitor leaving, not a failure, and is not reported. */
    var leaving = false;
    window.addEventListener('pagehide', function () { leaving = true; });
    window.addEventListener('beforeunload', function () { leaving = true; });
    window.addEventListener('pageshow', function () { leaving = false; });

    function ours(file) {
      if (!file) return false;
      var f = String(file);
      // Shopify's own platform scripts ride on our domain but are not ours.
      if (/\/cdn\/(shopifycloud|wpm)\/|\/checkouts\//.test(f)) return false;
      // Theme assets (/cdn/shop/t/<n>/), product files (/cdn/shop/files/) and
      // inline scripts, which carry the page URL.
      return f.indexOf(location.origin) === 0 || /^\/(?!\/)/.test(f);
    }
    function frames(stack) {
      if (!stack) return undefined;
      return String(stack).split('\n').slice(0, 4)
        .map(function (l) { return l.replace(/https?:\/\/[^\s)]*\/([^/\s)?]+)(\?[^\s):]*)?/g, '$1').trim(); })
        .join(' | ').slice(0, 240);
    }
    function reportError(msg, file, extra) {
      if (errorsSent >= 5) return;
      errorsSent++;
      var origin = file ? String(file).split('/').pop().split('?')[0].slice(0, 40) : '';
      var props = {
        // "Script error." with no file is the browser refusing to describe a
        // cross-origin failure. Kept as its own group rather than dropped: a
        // spike in it still means a third-party script broke.
        error_group: (normalise(msg) + (origin ? ' @' + origin : '')).slice(0, 100),
        third_party: !ours(file),
        content_group: group()
      };
      if (extra) for (var k in extra) if (extra[k] !== undefined && extra[k] !== null) props[k] = extra[k];
      ga('event', 'js_error', props);
    }
    window.addEventListener('error', function (e) {
      // Resource load failures (a 404 image) arrive here too, with no message.
      if (e && e.target && e.target !== window && e.target.tagName) {
        /* Custom elements (Shopify's <shopify-account> is the one this shop
           actually hits) carry neither src nor href, so the group collapsed to
           a bare tag name — 48 events in a fortnight naming a tag and nothing
           locatable. Fall back to the element's own id/class so the failing
           node can be found in the page. */
        var t = e.target;
        var where = t.src || t.href;
        if (!where) {
          where = (t.id ? '#' + t.id : '') ||
                  (typeof t.className === 'string' && t.className
                    ? '.' + t.className.trim().split(/\s+/)[0] : '') ||
                  '(no-src)';
        }
        if (leaving) return;
        reportError('resource failed: ' + t.tagName.toLowerCase(), where, { error_kind: 'resource' });
        return;
      }
      reportError(e && e.message, e && e.filename, {
        error_kind: 'script',
        error_source: e && e.filename
          ? String(e.filename).split('/').pop().split('?')[0].slice(0, 60) + ':' + (e.lineno || 0) + ':' + (e.colno || 0)
          : undefined,
        error_stack: frames(e && e.error && e.error.stack)
      });
    }, true);
    window.addEventListener('unhandledrejection', function (e) {
      var r = e && e.reason;
      var msg = (r && (r.message || r)) || 'unknown';
      /* The View Transition API rejects its promises when a transition is
         skipped (a second navigation, or skipTransition()). That is the API
         working as designed, not a failure anyone can see. */
      if (r && r.name === 'AbortError' && /transition/i.test(String(msg))) return;
      if (/skipTransition\(\) was called/.test(String(msg))) return;
      var stack = r && r.stack;
      var top = stack && /(https?:\/\/[^\s)]+):(\d+):(\d+)/.exec(String(stack));
      reportError('unhandled rejection: ' + msg, (r && r.fileName) || (top && top[1]), {
        error_kind: 'rejection',
        error_source: top ? top[1].split('/').pop().split('?')[0].slice(0, 60) + ':' + top[2] + ':' + top[3] : undefined,
        error_stack: frames(stack)
      });
    });

    /* ---------- web_vital ----------
       PerformanceObserver only, no library: web-vitals is 2KB gzipped but it is
       another request on a store whose mobile budget is already spent.

       Reported once, at the end of the visit, because all three are provisional
       until then — LCP can be replaced by a later paint, CLS accumulates, and
       INP is the worst interaction of the session, not the first. */
    (function () {
      if (typeof PerformanceObserver !== 'function') return;
      var lcp = 0, cls = 0, inp = 0, sent = false;

      /* A page that loads in a background tab — opened with cmd-click, restored
         on browser start, prerendered — does not paint until it is looked at,
         so its LCP is the time until the visitor got round to it. Measured on
         this store during verification: 24.7 seconds, rated "poor", entirely
         fictional. web-vitals solves this by refusing to report LCP that
         happened after the page was first hidden, and so does this. */
      var firstHidden = document.visibilityState === 'hidden' ? 0 : Infinity;
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') firstHidden = Math.min(firstHidden, performance.now());
      }, { capture: true });

      function observe(type, cb, opts) {
        try {
          var o = new PerformanceObserver(function (list) { list.getEntries().forEach(cb); });
          o.observe(Object.assign({ type: type, buffered: true }, opts || {}));
        } catch (e) { /* unsupported entry type — skip that metric only */ }
      }

      observe('largest-contentful-paint', function (e) { lcp = e.startTime; });
      observe('layout-shift', function (e) {
        // hadRecentInput excludes shifts the visitor caused themselves, which
        // is what makes CLS a layout bug metric rather than a scroll metric.
        if (!e.hadRecentInput) cls += e.value;
      });
      observe('event', function (e) {
        if (e.duration > inp) inp = e.duration;
      }, { durationThreshold: 40 });

      function rate(name, v) {
        if (name === 'LCP') return v <= 2500 ? 'good' : v <= 4000 ? 'needs-improvement' : 'poor';
        if (name === 'INP') return v <= 200 ? 'good' : v <= 500 ? 'needs-improvement' : 'poor';
        return v <= 100 ? 'good' : v <= 250 ? 'needs-improvement' : 'poor';   // CLS ×1000
      }
      function flush() {
        if (sent) return;
        sent = true;
        var metrics = [
          ['LCP', Math.round(lcp)],
          ['CLS', Math.round(cls * 1000)],
          ['INP', Math.round(inp)]
        ];
        for (var i = 0; i < metrics.length; i++) {
          // Drop LCP when it never fired (0, e.g. a bfcache restore) or when it
          // landed after the tab was first hidden — see firstHidden above.
          if (metrics[i][0] === 'LCP' && (!metrics[i][1] || lcp > firstHidden)) continue;
          ga('event', 'web_vital', {
            metric_name: metrics[i][0],
            metric_value: metrics[i][1],
            metric_rating: rate(metrics[i][0], metrics[i][1]),
            content_group: group()
          });
        }
      }
      // pagehide alone misses the iOS case where the tab is backgrounded and
      // never formally unloaded; visibilitychange alone misses same-page
      // navigations in some browsers. Both, with the once-guard above.
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') flush();
      });
      window.addEventListener('pagehide', flush);
    })();

    /* ---------- rage_click ----------
       Three clicks on the same element within a second and within 40px of each
       other. The distance test is what separates rage from a legitimate rapid
       double-press on a quantity stepper, which lands on the same element but
       is deliberate — the stepper is excluded outright below for the same
       reason, along with every other control whose job is repeated pressing. */
    var recent = [];
    var raged = {};
    var REPEATABLE = 'quantity-selector-component, .slideshow-control, [name="minus"], [name="plus"], .slideshow-controls__thumbnail';

    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      var now = Date.now();
      recent.push({ el: el, t: now, x: e.clientX, y: e.clientY });
      if (recent.length > 6) recent.shift();

      if (!el.closest(REPEATABLE)) {
        var hits = recent.filter(function (c) {
          return c.el === el && now - c.t < 1000 &&
                 Math.abs(c.x - e.clientX) < 40 && Math.abs(c.y - e.clientY) < 40;
        });
        var key = describe(el);
        if (hits.length >= 3 && !raged[key]) {
          raged[key] = true;
          ga('event', 'rage_click', {
            element_id: key,
            element_text: ((el.textContent || '').replace(/\s+/g, ' ').trim()).slice(0, 60) || undefined,
            content_group: group()
          });
        }
      }
    }, true);

    /* ---------- dead_click ----------
       Only for clicks with no interactive ancestor: anything inside a link,
       button, form control or [role=button] did something by definition, and
       watching those would report every working control on the page.

       "Changed nothing" is then proved rather than assumed — a MutationObserver
       for 600ms, plus checks on the URL and the scroll position, because this
       theme opens drawers by mutating the DOM and navigates without a reload.
       The observer is created per candidate click and disconnected on the
       timeout, so a page nobody misclicks on never allocates one.

       Capped at five candidates per page. Beyond that the page has a layout
       problem, not five separate ones — and the cap counts CANDIDATES, not
       sends, because
       the verdict arrives 600ms after the click: four rapid clicks all passed a
       send-counter cap before any of them had incremented it, and reported five
       dead clicks for one frustrated visitor.

       An element that already produced a rage_click is skipped outright. Both
       events describe the same moment, and rage_click is the stronger reading
       of it. */
    var INTERACTIVE = 'a[href], button, input, select, textarea, label, summary, details, ' +
                      '[role="button"], [role="link"], [role="tab"], [onclick], [contenteditable], ' +
                      'dialog, video, audio, [tabindex]:not([tabindex="-1"])';
    var deadSeen = 0;

    document.addEventListener('click', function (e) {
      if (deadSeen >= 5) return;
      var el = e.target;
      if (!el || !el.closest || el.closest(INTERACTIVE)) return;
      // Custom elements are how this theme ships behaviour (quick-add,
      // slideshow, variant picker). A click inside one is never dead by
      // default, so exclude the whole family rather than guess names.
      if (el.closest('[on\\:click], quick-add-component, slideshow-component, media-gallery, ' +
                     'cart-items-component, product-form-component, facets-form-component')) return;
      // Clicking blank layout is not a misclick, it is a click. Require
      // something that could plausibly look pressable.
      var looksPressable = el.tagName === 'IMG' || el.tagName === 'SVG' ||
                           ((el.textContent || '').trim().length > 0 && el.children.length < 4);
      if (!looksPressable) return;

      var key = describe(el);
      // Checked here as well as in the timeout: a rage-clicked element used to
      // burn the whole page budget on candidates that were then thrown away,
      // so a genuine dead click later on the page was never looked at.
      if (raged[key]) return;
      deadSeen++;                       // counted here, not in the timeout below
      var url = location.href;
      var scroll = window.scrollY + (document.scrollingElement ? document.scrollingElement.scrollTop : 0);
      var changed = false;
      var obs;
      try {
        obs = new MutationObserver(function () { changed = true; });
        obs.observe(document.body, { childList: true, subtree: true, attributes: true });
      } catch (err) { return; }

      setTimeout(function () {
        obs.disconnect();
        var scrolledNow = window.scrollY + (document.scrollingElement ? document.scrollingElement.scrollTop : 0);
        if (changed || location.href !== url || Math.abs(scrolledNow - scroll) > 10) return;
        if (raged[key]) return;         // already reported, more strongly
        ga('event', 'dead_click', {
          element_id: key,
          element_text: ((el.textContent || '').replace(/\s+/g, ' ').trim()).slice(0, 60) || undefined,
          content_group: group()
        });
      }, 600);
    }, true);
  })();
